const VALUES = [
  { label: "Love", fill: "#5A2D9C", d: <path d="M12 20s-7-4.3-9.3-8.6C1.3 8.4 3 4.6 6.6 4.6c2 0 3.4 1.1 4.1 2.3h.6c.7-1.2 2.1-2.3 4.1-2.3 3.6 0 5.3 3.8 3.9 6.8C19 15.7 12 20 12 20z" /> },
  { label: "Educate", fill: "#5A2D9C", d: <path d="M12 3 1 9l11 6 9-4.9V17h2V9L12 3zm-6 9.2V16c0 1.7 2.7 4 6 4s6-2.3 6-4v-3.8l-6 3.3-6-3.3z" /> },
  { label: "Empower", fill: "#F4B41A", d: <><circle cx="12" cy="4.5" r="2.5" /><path d="M4 7.5l1-1.8L12 9l7-3.3 1 1.8-6 3V14l3 7h-2.3L12 15.5 9.3 21H7l3-7v-3.5z" /></> },
  { label: "Include", fill: "#F4B41A", d: <path d="M12 3 2 11.5h3V21h5v-6h4v6h5v-9.5h3z" /> },
];

export const About = () => (
  <section className="sec" id="about" data-testid="about-section">
    <div className="wrap about-grid">
      <div>
        <div className="head"><h2>About us</h2></div>
        <div className="about-text">
          <p>I founded Davis Infinite Care Corporation after seeing how difficult it can be for people from all walks of life to find, connect with, and receive help when they need it most. My personal experiences with individuals and families facing different challenges showed me the value of having someone who will listen, care, and help them find a path forward.</p>
          <p>Our nonprofit works to connect people with support and resources. We care deeply about individuals experiencing homelessness or mental health challenges, as well as families seeking autism support, disability resources, and elder care guidance. We also recognize the caregivers who work every day to support their loved ones.</p>
          <p>At Davis Infinite Care Corporation, our mission is to make those connections easier and help build a more inclusive community. We believe everyone deserves to be treated with dignity, to feel seen and valued, and to know they do not have to face life's challenges alone.</p>
          <div className="founder" data-testid="about-founder-signoff">
            <span className="founder-name">Jeanine Davis</span>
            <span className="founder-title">President of Davis Infinite Care Corporation</span>
          </div>
        </div>
      </div>
      <aside className="about-card" data-testid="about-card">
        <img src="/assets/logo-established.jpg" alt="Davis Infinite Care Corporation, established 2026" />
        <div className="values" aria-label="Our values">
          {VALUES.map((v) => (
            <span key={v.label} data-testid={`value-${v.label.toLowerCase()}`}>
              <svg viewBox="0 0 24 24" fill={v.fill}>{v.d}</svg>
              {v.label}
            </span>
          ))}
        </div>
      </aside>
    </div>
  </section>
);
